module.exports = __webpack_public_path__ + "img/ic_picto_map_pharma_normal.cc536bb7.svg";